import { OnInit } from '@angular/core';
var FroalaWysiwygComponent = /** @class */ (function () {
    function FroalaWysiwygComponent() {
    }
    FroalaWysiwygComponent.prototype.ngOnInit = function () { };
    return FroalaWysiwygComponent;
}());
export { FroalaWysiwygComponent };
